import React, { useEffect, useState } from 'react';

import Box from '@liquidweb-dev/undercurrent/Box';
import Button from '@liquidweb-dev/undercurrent/Button';
import Dialog from '@liquidweb-dev/undercurrent/Dialog';
import Stack from '@liquidweb-dev/undercurrent/Stack';
import Typography from '@liquidweb-dev/undercurrent/Typography';
import { useMasquerade } from 'modules/oidc/useAuthenticated';
import useAccountDetails from 'modules/queries/account/useDetails';
import useUserMetaState from 'modules/queries/account/user/stateData/useUserMetaState';
import accountStatuses from 'utility/constants/accountStatuses';

function DialogNewPortalWelcome() {
	const isMasquerade = useMasquerade();
	const [isOpen, setIsOpen] = useState(false);

	const {
		data: accountDetails,
		isLoading: isAccountDetailsLoading,
		isError: isAccountDetailsError,
	} = useAccountDetails({});

	const isActiveAccount =
		accountDetails?.account_status === accountStatuses.ACTIVE;
	const [
		isDismissed,
		setIsDismissed,
		{ isLoading: isDismissedLoading, isError: isDismissedError },
	] = useUserMetaState('newPortalWelcomeDismissed', false);

	const isLoading = isAccountDetailsLoading || isDismissedLoading;
	const isError = isAccountDetailsError || isDismissedError;

	// open the dialog if the user has not seen it yet
	useEffect(() => {
		if (isMasquerade || isLoading || isError || isDismissed || !isActiveAccount)
			return;

		setIsOpen(true);
	}, [isError, isLoading, isDismissed, isActiveAccount, isMasquerade]);

	if (isLoading || isDismissed) {
		return null;
	}

	const handleClose = (reason?: string) => {
		if (reason === 'backdropClick') {
			return;
		}
		setIsOpen(false);
		setIsDismissed(true);
	};

	return (
		<Dialog
			open={isOpen}
			onClose={(_event, reason) => handleClose(reason)}
			maxWidth="md"
			fullWidth
		>
			<Box
				component="video"
				sx={{
					width: '100%',
					objectFit: 'cover',
				}}
				controls
			>
				<source
					src="https://www.liquidweb.com/wp-content/uploads/2025/04/myliquidweb_april_update.webm"
					type="video/webm"
				/>
			</Box>

			<Stack
				sx={{ gap: 300, padding: { xs: 200, sm: 500 }, alignItems: 'center' }}
			>
				<Stack sx={{ gap: 100 }}>
					<Typography
						variant="title-xs"
						sx={{ fontWeight: 500, textAlign: 'center' }}
					>
						A fresh new look for your portal
					</Typography>
					<Typography
						variant="body-sm"
						sx={{ textAlign: 'center', maxWidth: '703px' }}
					>
						We&apos;re rebuilding the portal from the ground up with a cleaner
						design, smarter navigation, and easier access to the tools you use
						every day. It&apos;s the same power under the hood, now with a
						smoother, more focused experience. This is just the beginning — more
						updates are on the way.
					</Typography>
				</Stack>

				<Button onClick={() => handleClose()} size="large">
					I got it
				</Button>
			</Stack>
		</Dialog>
	);
}

export default DialogNewPortalWelcome;
